// ===================================================================
// services/secureAuthService.ts - VERSION COMPLÃˆTE AVEC ADMIN
// ===================================================================

interface User {
  id: string;
  email: string;
  name: string;
  picture?: string;
  createdAt: string;
  lastLogin?: string;
  isAdmin?: boolean;
  onboardingCompleted?: boolean;
  onboardingLevel?: string | null;
  onboardingObjective?: string | null;
}

interface SubscriptionStatus {
  isPremium: boolean;
  tier: 'free' | 'premium';
  status: string;
  expiresAt?: string;
  billingPeriod?: string;
  planId?: string;
}

interface AccessCheck {
  hasAccess: boolean;
  isPremium: boolean;
  tier: string;
  feature: string;
  reason?: string;
}

class SecureAuthService {
  private apiUrl: string;
  private token: string | null = null;
  private user: User | null = null;
  



  constructor() {
    // Configuration de l'URL API
    this.apiUrl = this.determineApiUrl();
    
   
    
    
    this.token = localStorage.getItem('secureToken');
    const storedUser = localStorage.getItem('secureUser');
    
    if (storedUser) {
      try {
        this.user = JSON.parse(storedUser);
     
        
     
        this.checkAndActivateAdminPremium();
      } catch (error) {
     
        localStorage.removeItem('secureUser');
      }
    }

   
    if (this.token) {
      this.verifyStoredToken();
    }
  }




  private isAdminUser(_email?: string): boolean {
    return this.user?.isAdmin === true;
  }


  private async checkAndActivateAdminPremium(): Promise<void> {
    if (!this.user || !this.isAdminUser(this.user.email)) {
      return;
    }

    try {
    
      
      // Importer le service de subscription dynamiquement pour éviter les imports circulaires
      const { default: subscriptionService, SubscriptionTier } = await import('./subscriptionService');
      
      // Activer Premium permanent pour l'admin (10 ans)
      const tenYearsFromNow = Date.now() + (10 * 365 * 24 * 60 * 60 * 1000);
      
      subscriptionService.updateSubscription(
        SubscriptionTier.PREMIUM,
        tenYearsFromNow,
        'admin_premium_auto',
        'yearly',
        'admin_premium_lifetime'
      );
      
    
      
    
      window.dispatchEvent(new CustomEvent('subscriptionUpdated', { 
        detail: { 
          tier: SubscriptionTier.PREMIUM, 
          planId: 'admin_premium_lifetime',
          isAdmin: true
        }
      }));
      
    } catch (error) {
}
  }


  public isCurrentUserAdmin(): boolean {
    return this.user ? this.isAdminUser(this.user.email) : false;
  }

  // ===================================================================
  // CONFIGURATION D'URL
  // ===================================================================

  private determineApiUrl(): string {
    // En production (Vercel)
    if (typeof window !== 'undefined' && window.location.hostname.includes('vercel.app')) {
      return 'https://jogolinga-backend-production.up.railway.app';
    }
    
    // Variables d'environnement
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    }
    
    if (process.env.NEXT_PUBLIC_API_URL) {
      return process.env.NEXT_PUBLIC_API_URL;
    }
    
   
    return 'http://localhost:3001';
  }




  async authenticatedFetch(endpoint: string, options: RequestInit = {}): Promise<Response> {
  if (!this.token) {
    this.logout();
    window.location.href = '/';
    throw new Error('Non authentifié');
  }

  const response = await fetch(`${this.apiUrl}${endpoint}`, {
    ...options,
    headers: {
      'Authorization': `Bearer ${this.token}`,
      'Content-Type': 'application/json',
      ...options.headers
    },
    mode: 'cors'
  });

  if (response.status === 401 || response.status === 403) {

    this.logout();
    window.location.href = '/';
    throw new Error('Session expirée');
  }

  return response;
}


  // ===================================================================
  // VÃ‰RIFICATION TOKEN - MODIFIÃ‰E
  // ===================================================================

  async verifyStoredToken(): Promise<boolean> {
    if (!this.token) return false;

    try {
      const response = await fetch(`${this.apiUrl}/api/auth/verify`, {
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Accept': 'application/json'
        },
        mode: 'cors'
      });

      if (response.ok) {
        const data = await response.json();
        if (data.valid && data.user) {
          this.user = data.user;
          localStorage.setItem('secureUser', JSON.stringify(data.user));
       
          await this.checkAndActivateAdminPremium();
          
       
          return true;
        }
      }

     
      this.logout();
      return false;
    } catch (error) {
this.logout();
      return false;
    }
  }

  logout(): void {

  
  this.token = null;
  this.user = null;
  localStorage.removeItem('secureToken');
  localStorage.removeItem('secureUser');
  localStorage.removeItem('googleToken');
  localStorage.removeItem('tokenExpires');
  localStorage.removeItem('user_subscription');

  // 🆕 Notifier GoogleAuth de la déconnexion
  window.dispatchEvent(new Event('sessionExpired'));
  
  window.dispatchEvent(new CustomEvent('authStatusChanged', { 
    detail: { isAuthenticated: false, user: null }
  }));


}

  // ===================================================================
  // VÃ‰RIFICATIONS D'ABONNEMENT
  // ===================================================================

  async verifySubscription(): Promise<SubscriptionStatus> {
    if (!this.token) {
      return { isPremium: false, tier: 'free', status: 'unauthenticated' };
    }

    try {
      const response = await this.authenticatedFetch('/api/subscription/verify');

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      const subscription = await response.json();
      

      return subscription;
    } catch (error) {
return { isPremium: false, tier: 'free', status: 'error' };
    }
  }

  async checkAccess(feature: string): Promise<AccessCheck> {
    if (!this.token) {
      return {
        hasAccess: false,
        isPremium: false,
        tier: 'free',
        feature,
        reason: 'Authentification requise'
      };
    }

    try {
      const response = await fetch(`${this.apiUrl}/api/subscription/check-access`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ feature }),
        mode: 'cors'
      });

      if (!response.ok) {
        if (response.status === 401) {
          this.logout();
          throw new Error('Session expirée');
        }
        throw new Error(`Erreur ${response.status}`);
      }

      const access = await response.json();
     

      return access;
    } catch (error) {
    
      return {
        hasAccess: false,
        isPremium: false,
        tier: 'free',
        feature,
        reason: 'Erreur de vérification'
      };
    }
  }

  // ===================================================================
  // PAIEMENTS
  // ===================================================================

  // ===================================================================
  // PROGRESSION UTILISATEUR
  // ===================================================================


  private async testBackendConnectivity(): Promise<void> {
    try {
     
      
      const healthEndpoints = [
        `${this.apiUrl}/api/health`,
        `${this.apiUrl}/health`,
        `${this.apiUrl}/`
      ];

      for (const endpoint of healthEndpoints) {
        try {
          const response = await fetch(endpoint, {
            method: 'GET',
            mode: 'cors',
            headers: {
              'Accept': 'application/json'
            }
          });
          
          if (response.ok) {
         
            return;
          }
        } catch (error) {
     
        }
      }
      
      throw new Error('Backend inaccessible sur tous les endpoints testées');
    } catch (error) {
     
      throw new Error(`Backend non accessible (${this.apiUrl}). Vérifiez que le serveur est démarré.`);
    }
  }



  /**
   * Enregistre le niveau et l'objectif choisis à l'onboarding (table users).
   * fetchWithAnyAuth : couvre aussi les comptes Google (session Supabase) ;
   * avec authenticatedFetch + this.token, rien n'était envoyé pour eux et
   * onboarding_level / onboarding_objective restaient à NULL.
   * Renvoie true si le serveur a bien enregistré.
   */
  async completeOnboarding(level: string | null, objective: string | null): Promise<boolean> {
    try {
      const res = await this.fetchWithAnyAuth('/api/onboarding/complete', {
        method: 'POST',
        body: JSON.stringify({ level, objective })
      });
      if (!res?.ok) return false; // invité (null) ou erreur serveur
      if (this.user) {
        this.user.onboardingCompleted = true;
        this.user.onboardingLevel = level;
        this.user.onboardingObjective = objective;
        localStorage.setItem('secureUser', JSON.stringify(this.user));
      }
      return true;
    } catch {
      // Silent — localStorage reste le fallback
      return false;
    }
  }

  /**
   * Appel backend authentifié par le token propriétaire OU, à défaut, la
   * session Supabase (login Google OAuth). Contrairement à authenticatedFetch,
   * ne déconnecte pas et ne redirige pas sur 401/403 : réservé aux appels
   * « best effort » (tokens FCM, notifications de défi).
   * Retourne null si aucun token n'est disponible.
   */
  async fetchWithAnyAuth(endpoint: string, options: RequestInit = {}): Promise<Response | null> {
    let authToken = this.token;
    if (!authToken) {
      const { supabase } = await import('./supabaseAudioService');
      const { data } = await supabase.auth.getSession();
      authToken = data.session?.access_token ?? null;
    }
    if (!authToken) return null;

    return fetch(`${this.apiUrl}${endpoint}`, {
      ...options,
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      mode: 'cors',
    });
  }

  async deleteAccount(): Promise<void> {
    // Priorité : secureToken (login propriétaire), sinon session Supabase (Google OAuth)
    let authToken = this.token;
    if (!authToken) {
      const { supabase } = await import('./supabaseAudioService');
      const { data } = await supabase.auth.getSession();
      authToken = data.session?.access_token ?? null;
    }
    if (!authToken) throw new Error('Non authentifié');

    const response = await fetch(`${this.apiUrl}/api/user/account`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      },
      mode: 'cors',
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.error || `Erreur ${response.status}`);
    }

    // Nettoyer toutes les données locales après suppression
    this.logout();
  }

  getCurrentUser(): User | null {
    return this.user;
  }

  isAuthenticated(): boolean {
    return !!(this.token && this.user);
  }

  getAuthHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };

    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    return headers;
  }

  

 
}

// Export singleton
const secureAuthService = new SecureAuthService();
export default secureAuthService;

// Disponible dans la console uniquement en développement
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  (window as any).secureAuthService = secureAuthService;
}